import React from 'react';

const CredentialsSection = () => {
  return (
    <section data-screen-label="Credentials" style={{ padding: 'clamp(40px, 4.5vw, 64px) clamp(16px, 4vw, 48px)', background: '#26332C', textAlign: 'center' }}>
      <div
        style={{
          maxWidth: '1120px',
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'column',
          gap: '32px',
          alignItems: 'center',
        }}
      >
        <h2 style={{ fontFamily: "'Montserrat', sans-serif", fontSize: 'clamp(22px, 4vw, 32px)', color: '#FBFAF6', margin: 0, fontWeight: 800 }}>
          Licensed. Credentialed. Independent.
        </h2>
        <div className="credentials-grid" style={{ maxWidth: '920px' }}>
          <div
            style={{
              background: 'rgba(252, 253, 254, 0.06)',
              border: '1px solid rgba(252, 253, 254, 0.15)',
              borderRadius: '14px',
              padding: '26px 22px',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              textAlign: 'center',
            }}
          >
            <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '16px', fontWeight: 700, color: '#B5652E' }}>
              UAE Trade License
            </div>
            <div style={{ fontSize: '14px', color: '#D8D2C2', lineHeight: '1.6' }}>
              Licensed private consulting firm based in Dubai. Trade License No. 795106
            </div>
          </div>
          <div
            style={{
              background: 'rgba(252, 253, 254, 0.06)',
              border: '1px solid rgba(252, 253, 254, 0.15)',
              borderRadius: '14px',
              padding: '26px 22px',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              textAlign: 'center',
            }}
          >
            <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '16px', fontWeight: 700, color: '#B5652E' }}>
              Chartered Accountants
            </div>
            <div style={{ fontSize: '14px', color: '#D8D2C2', lineHeight: '1.6' }}>
              Our team holds CA and ICAI professional memberships with decades of combined practice.
            </div>
          </div>
          <div
            style={{
              background: 'rgba(252, 253, 254, 0.06)',
              border: '1px solid rgba(252, 253, 254, 0.15)',
              borderRadius: '14px',
              padding: '26px 22px',
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              textAlign: 'center',
            }}
          >
            <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '16px', fontWeight: 700, color: '#B5652E' }}>
              Fully Independent
            </div>
            <div style={{ fontSize: '14px', color: '#D8D2C2', lineHeight: '1.6' }}>
              Not affiliated with the Federal Tax Authority (FTA) or any UAE government entity.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CredentialsSection;
